import { render, staticRenderFns } from "./KitDeleteDialog.vue?vue&type=template&id=f4be1c46"
import script from "./KitDeleteDialog.vue?vue&type=script&lang=js"
export * from "./KitDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports